import React from 'react';
import { ArrowRight } from 'react-feather';

interface IDocumentationCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  badge?: string;
  onClick?: () => void;
}

const DocumentationCard: React.FC<IDocumentationCardProps> = ({
  title,
  description,
  icon,
  badge,
  onClick
}) => {
  return (
    <div className="kh-doc-card" onClick={onClick}>
      <div className="kh-doc-card__header">
        <div className="kh-doc-card__icon">{icon}</div>
        {badge && <span className={`kh-doc-card__badge kh-doc-card__badge--${badge.toLowerCase()}`}>{badge}</span>}
      </div>
      <div className="kh-doc-card__content">
        <h3 className="kh-doc-card__title">{title}</h3>
        <p className="kh-doc-card__description">{description}</p>
      </div>
      <div className="kh-doc-card__footer">
        <button className="kh-doc-card__link">
          Read Documentation <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
};

export default DocumentationCard;
